module.exports = __webpack_public_path__ + "files/b3803428a3cec5c1b1185ef92d254e26.svg";